import 'react-dates/initialize';

import { DateRangePicker } from 'react-dates';

import _ from 'lodash';
import classNames from 'clsx';
import React from 'react';
import moment from 'moment';
import SearchActions from '../../actions/SearchActions';
import SortActions from '../../actions/SortActions';
import SearchStore from '../../stores/SearchStore';
import ProfileStore from '../../stores/ProfileStore';
import ResultsStore from '../../stores/ResultsStore';
import PointsStore from '../../stores/PointsStore';
import SearchService from '../../utils/SearchService';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import DomService from './helpers/DomService';

import Analytics from 'arbitrip-common/client/analytics';
import { getPointsToggleState } from 'arbitrip-common/client/analytics/services/loyaltyService';
import RouterWrapper from '../../utils/RouterWrapper';
import { isSearchModified } from '../../utils/searchModified';
import SearchAutocomplete from './SearchAutocomplete.react';
import SearchData from './search-data/SearchData.react';
import SearchMessage from './SearchMessage.react';
import SEARCH_CONSTANTS from 'arbitrip-common/general/constants/search-constants';
import { SEARCH_TYPES, VARIANT, START_DATE_ID, END_DATE_ID, SEARCH_BOX_ID } from './constants';
import { withRouter } from '../../utils/withRouter';
import Dates from '../../utils/Dates';
import SearchIcon from './SearchIcon';
import { ReactComponent as CalendarIcon } from '../../img/search_page/search_bar/calendar.svg';
import { ReactComponent as UserIcon } from '../../img/search_page/search_bar/user.svg';
import { RTL } from 'arbitrip-common/translation/const';
import { isSamlRedirectNeeded } from '@/hooks/useSamlPageVerification';
import { ANONYMOUS_PERMISSION_SEARCH_RESULTS } from 'arbitrip-common/client/utils/ElalSamlVerification';

import { withStyles } from '@mui/styles';

const delay_timeout = 2 * 1000;
const delay_options = {
	leading: true,
	trailing: false,
};

function getState() {
	return {
		profile: ProfileStore.getProfile(),
		store_search_terms: SearchStore.getSearchTerms(),
	};
}

const yesterday = moment.utc().subtract(1, 'day').startOf('day');
const maxDate = moment.utc().add(1, 'y').startOf('day');

const globalStyles = {
	'@global': {
		'.DateInput[dir="rtl"] input': {
			textAlign: 'right !important',
		},
		'.SingleDatePickerInput[dir="rtl"] .DateInput input': {
			textAlign: 'right !important',
		},
		'.DateRangePicker[dir="rtl"] .DateInput input': {
			textAlign: 'right !important',
		},
		'[dir="rtl"] .DateRangePickerInput .DateInput input': {
			textAlign: 'right !important',
		},
	},
};

class SearchFull extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			autocompleteLoading: false,
			focusedDateInput: null,
			focusedGuestsInput: null,
			showPreviousMonthButtonOnCalendar: true,
			showNextMonthButtonOnCalendar: true,
			showChildrenAgesError: false,
			..._.extend(SearchStore.getSearchTerms(), getState()),
		};

		this.searchDataRef = React.createRef();
		this.searchDataButtonRef = React.createRef();

		this._onChange = this._onChange.bind(this);
		this.onLoadingDestination = this.onLoadingDestination.bind(this);
		this.onDatesChange = this.onDatesChange.bind(this);
		this.onGuestsChange = this.onGuestsChange.bind(this);
		this.onRoomsChange = this.onRoomsChange.bind(this);
		this.onPrevMonthClick = this.onPrevMonthClick.bind(this);
		this.onNextMonthClick = this.onNextMonthClick.bind(this);
		this.onChildrenChange = this.onChildrenChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onSearch = _.debounce(this.onSearch, delay_timeout, delay_options);
		this.onUpdateDestinationSearch = this.onUpdateDestinationSearch.bind(this);
		this.openDatesWindow = this.openDatesWindow.bind(this);
	}
	
	shouldComponentUpdate(nextProps, nextState) {
    	return (
        !_.isEqual(this.state, nextState) ||
        !_.isEqual(this.props.history.location, nextProps.history.location) ||
        Object.keys(this.props).some(k => k !== 'history' && !_.isEqual(this.props[k], nextProps[k]))
    	);
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			!_.isEqual(
				_.get(prevState, 'store_search_terms.destination', {}),
				_.get(this.state, 'store_search_terms.destination', {}),
			)
		) {
			// update destination if change in store
			this.setState({
				address: this.state.store_search_terms.address,
				destination: this.state.store_search_terms.destination,
				location: this.state.store_search_terms.location,
				hotel_id: this.state.store_search_terms.hotel_id,
			});

			setTimeout(() => {
				this.openDatesWindow();
			});
		}

		if (
			!_.isEqual(
				_.get(prevState, 'store_search_terms.rooms', 1),
				_.get(this.state, 'store_search_terms.rooms', 1),
			)
		) {
			// update rooms if change in store
			this.setState({
				rooms: this.state.store_search_terms.rooms,
			});
		}

		if (
			!_.isEqual(
				_.get(prevState, 'store_search_terms.guests', 1),
				_.get(this.state, 'store_search_terms.guests', 1),
			)
		) {
			// update guests if change in store
			this.setState({
				guests: this.state.store_search_terms.guests,
			});
		}

		if (
			!_.isEqual(
				_.get(prevState, 'store_search_terms.children_ages', []),
				_.get(this.state, 'store_search_terms.children_ages', []),
			)
		) {
			// update children_ages if change in store
			this.setState({
				children_ages: this.state.store_search_terms.children_ages,
			});
		}

		if (
			!_.isEqual(
				_.get(prevState, 'store_search_terms.check_in', null),
				_.get(this.state, 'store_search_terms.check_in', null),
			)
		) {
			// update check_in if change in store
			this.setState({
				check_in: this.state.store_search_terms.check_in,
			});
		}

		if (
			!_.isEqual(
				_.get(prevState, 'store_search_terms.check_out', null),
				_.get(this.state, 'store_search_terms.check_out', null),
			)
		) {
			// update check_out if change in store
			this.setState({
				check_out: this.state.store_search_terms.check_out,
			});
		}

		if (
			!_.isEqual(
				_.get(prevState, 'store_search_terms.contract_id', null),
				_.get(this.state, 'store_search_terms.contract_id', null),
			)
		) {
			// update contract id
			// when search we build the url from current component state
			this.setState({
				contract_id: this.state.store_search_terms.contract_id,
			});
		}

		if (this.getAddress(this.state.destination) !== this.getAddress(prevState.destination)) {
			const searchBoxElement = document.getElementById(SEARCH_BOX_ID);
			if (window.Velocity && !DomService.isElementInViewport(searchBoxElement)) {
				window.Velocity(searchBoxElement, 'scroll', {
					duration: 600,
					offset: -100,
					easing: 'ease-in-out',
				});
			}
		}

		if (this.state.showChildrenAgesError && SearchService.areChildrenAgesValid(this.state)) {
			this.setState({ showChildrenAgesError: false });
		}
	}

	getAddress(destination) {
		return destination && destination.address;
	}

	onLoadingDestination(loading) {
		this.setState({ autocompleteLoading: loading });
	}

	onUpdateDestinationSearch(item) {
		console.log('onUpdateDestinationSearch', item);

		if (item && item.category === SEARCH_TYPES.RECENT_SEARCH) {
			SearchActions.updateSearchTerms(item.terms);
		} else {
			SearchActions.updateDestination(item);

			this.openDatesWindow();
		}
	}

	openDatesWindow() {
		const { check_in, check_out, destination } = this.state;

		if (check_in) {
			this.onPrevMonthClick(check_in);
		}

		if (!destination) {
			return;
		}

		if (window.$) {
			if (!check_in) {
				window.$(`#${START_DATE_ID}`).focus();
			} else if (!check_out) {
				window.$(`#${END_DATE_ID}`).focus();
			}
		} else {
			console.log('jQuery is not initiated!');
		}
	}

	openDataWindow = () => {
		if (this.searchDataRef.current) {
			this.searchDataRef.current.toggleWindow(true);
			this.setState({ focusedGuestsInput: true });
		}
	};

	handleDataWindowToggle = (isFocused) => {
		this.setState({ focusedGuestsInput: isFocused });
	};

	onDatesChange(startDate, endDate) {
		if (startDate) {
			SearchActions.updateCheckIn(startDate);
		}

		if (endDate) {
			SearchActions.updateCheckOut(endDate);
			this.searchDataButtonRef?.current?.focus();
		}
	}

	searchIsValid() {
		const { autocompleteLoading } = this.state;

		return SearchService.isValid(this.state) && !autocompleteLoading;
	}

	onGuestsChange(guests) {
		SearchActions.updateGuests(guests);
	}

	onRoomsChange(rooms) {
		SearchActions.updateRooms(rooms);
	}

	onChildrenChange(childrenAges) {
		SearchActions.updateChildrenAges(childrenAges);
	}

	onSearch(e) {
		if (!this.searchIsValid()) {
			return;
		}

		const { navigate } = this.props;
		const clonedState = _.clone(this.state);

		SearchActions.updateSearchData(clonedState);

		if (SearchService.isValid(this.state)) {
			// // temp workaround for bad change search beheviour
			// RouterWrapper.goToResultsPage(clonedState);
			// if (this.props.variant === VARIANT.SMALL) {
			//     return RouterWrapper.refresh();
			// }

            const isRedirecting = isSamlRedirectNeeded(ANONYMOUS_PERMISSION_SEARCH_RESULTS);
			if (!e.metaKey && !e.ctrlKey && !isRedirecting) {
				SearchActions.search();
				const placeTypes = this.state.destination?.place?.types;
				const isGooglePoi = this.state.destination?.place?.place_id
					&& Array.isArray(placeTypes)
					&& (placeTypes.includes('lodging') || placeTypes.includes('point_of_interest'));
				if (isGooglePoi) {
					SortActions.sortByDistance();
				}
				

				const { profile, contract_id } = this.state;
				const client = contract_id ? SearchStore.getContractClientName() + ' (' + contract_id + ')' : null;

				Analytics.actions.interactions.executedSearch(
					profile,
					this.state.destination,
					this.state, //all the search data is on the state
					client,
					null,
					{
						is_loyalty_member: !!(profile && profile.loyalty && profile.loyalty.enabled),
						points_balance: PointsStore.getBalance(),
						points_toggle_state: getPointsToggleState(ResultsStore.getShowPricesInPoints()),
						search_destination: this.state.destination && this.state.destination.address,
						is_search_modified: isSearchModified(SearchStore.getSearchTerms()),
					},
				);
			}
		} else {
			// shakes the search box when not all search terms are valid...
			window.Velocity(document.getElementById(SEARCH_BOX_ID), 'callout.shake', {});
		}

		RouterWrapper.goToResultsPage(navigate, clonedState);
	}

	handleSearch = (event) => {
		if (this.searchIsValid()) {
			const areChildrenAgesValid = SearchService.areChildrenAgesValid(this.state);
			if (areChildrenAgesValid) {
				this.onSearch(event);
			} else {
				this.setState({ showChildrenAgesError: true });
				this.openDataWindow();
			}
		}
	};

	getSearchButton() {
		return (
			<button
				className={classNames('search', !this.searchIsValid() && 'search-disabled default-style')}
				onClick={this.handleSearch}
				aria-label="Search"
				aria-disabled={!this.searchIsValid()}
				onFocus={() => {
					this.searchDataRef.current.closeWindow();
					this.setState({ focusedGuestsInput: false });
				}}
				data-testid="search-button"
			>
				<SearchIcon />
			</button>
		);
	}

	getDateLabels(focusedDateInput) {
		const { t } = this.props;
		return ['startDate', 'endDate'].map((dateType) => (
			<span
				key={dateType}
				className={classNames(
					'label',
					dateType === 'startDate' ? 'check-in' : 'check-out',
					focusedDateInput === dateType && 'focused',
				)}
			>
				{dateType === 'startDate' ? t('Search.CheckIn') : t('Search.CheckOut')}
			</span>
		));
	}

	onNextMonthClick(t) {
		const showPreviousMonthButtonOnCalendar = t.clone().startOf('month').isAfter(moment.utc().startOf('month'));
		const showNextMonthButtonOnCalendar = t
			.clone()
			.add(1, 'M')
			.startOf('month')
			.add(1, 'd')
			.isBefore(maxDate.clone().startOf('month'));
		this.setState({
			showPreviousMonthButtonOnCalendar,
			showNextMonthButtonOnCalendar,
		});
	}

	onPrevMonthClick(t) {
		const showPreviousMonthButtonOnCalendar = t.clone().startOf('month').isAfter(yesterday);
		const showNextMonthButtonOnCalendar = t
			.clone()
			.add(1, 'M')
			.startOf('month')
			.add(1, 'd')
			.isBefore(maxDate.clone().startOf('month'));
		this.setState({
			showPreviousMonthButtonOnCalendar,
			showNextMonthButtonOnCalendar,
		});
	}

	getDateIcons(focusedDateInput) {
		return ['startDate', 'endDate'].map((dateType) => (
			<CalendarIcon
				key={dateType}
				className={`calendar-icon ${dateType === 'startDate' ? 'check-in' : 'check-out'}`}
				aria-hidden="true"
			/>
		));
	}

	getNumberOfNights() {
		return SearchService.getNumberOfNights(this.state);
	}

	render() {
		const {
			destination,
			check_in,
			check_out,
			focusedDateInput,
			guests,
			rooms,
			children_ages,
			focusedGuestsInput,
			showPreviousMonthButtonOnCalendar,
			showNextMonthButtonOnCalendar,
			profile,
		} = this.state;
		const { variant, t, i18n } = this.props;

		const isRTL = i18n.dir() === RTL;

		return (
			<div>
				<div
					id={SEARCH_BOX_ID}
					className={classNames('search-box-container', variant === VARIANT.SMALL && VARIANT.SMALL)}
					style={this.props.style}
				>
					<div className="search-box-wrap">
						<div className={classNames('autocomplete')}>
							<div className="autocomplete-wrap">
								<SearchAutocomplete
									value={destination}
									onLoading={this.onLoadingDestination}
									onUpdate={this.onUpdateDestinationSearch}
									autoFocus={false}
									privateTravel={this.state.private_travel}
								/>
							</div>
						</div>
						<div onClick={() => this.openDatesWindow()} className="dates">
							{this.getDateLabels(focusedDateInput)}
							{this.getDateIcons(focusedDateInput)}

							<DateRangePicker
								renderDayContents={(day) => (
									<span data-date={day.format('YYYY-MM-DD')}>{day.date()}</span>
								)}
								minimumNights={0}
								startDate={check_in}
								startDateId={START_DATE_ID}
								endDate={check_out}
								endDateId={END_DATE_ID}
								onDatesChange={({ startDate, endDate }) => this.onDatesChange(startDate, endDate)}
								focusedInput={focusedDateInput}
								onFocusChange={(focusedDateInput) => this.setState({ focusedDateInput })}
								displayFormat="D MMM"
								startDatePlaceholderText={t('Search.DatePlaceholder')}
								endDatePlaceholderText={t('Search.DatePlaceholder')}
								noBorder={true}
								hideKeyboardShortcutsPanel={true}
								readOnly={true}
								onNextMonthClick={this.onNextMonthClick}
								onPrevMonthClick={this.onPrevMonthClick}
								navPrev={showPreviousMonthButtonOnCalendar ? null : <div />}
								navNext={showNextMonthButtonOnCalendar ? null : <div />}
								renderNavPrevButton={showPreviousMonthButtonOnCalendar ? ({ ariaLabel, disabled, onClick, onKeyUp, onMouseUp }) => (
									<div
										role="button"
										tabIndex="0"
										className={[
											'DayPickerNavigation_button',
											'DayPickerNavigation_button__default',
											'DayPickerNavigation_button__horizontal',
											'DayPickerNavigation_button__horizontalDefault',
											isRTL ? 'DayPickerNavigation_rightButton__horizontalDefault' : 'DayPickerNavigation_leftButton__horizontalDefault',
										].join(' ')}
										aria-label={ariaLabel}
										aria-disabled={disabled ? true : undefined}
										onClick={disabled ? undefined : onClick}
										onKeyUp={disabled ? undefined : onKeyUp}
										onMouseUp={disabled ? undefined : onMouseUp}
										data-testid="go-prev-month"
									>
										<svg
											className="DayPickerNavigation_svg__horizontal"
											focusable="false"
											viewBox="0 0 1000 1000"
										>
											{isRTL ? (
												<path d="M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z" />
											) : (
												<path d="M336 275L126 485h806c13 0 23 10 23 23s-10 23-23 23H126l210 210c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7L55 524c-11-11-11-21 0-32l249-249c21-22 53 10 32 32z" />
											)}
										</svg>
									</div>
								) : undefined}
								renderNavNextButton={showNextMonthButtonOnCalendar ? ({ ariaLabel, disabled, onClick, onKeyUp, onMouseUp }) => (
									<div
										role="button"
										tabIndex="0"
										className={[
											'DayPickerNavigation_button',
											'DayPickerNavigation_button__default',
											'DayPickerNavigation_button__horizontal',
											'DayPickerNavigation_button__horizontalDefault',
											isRTL ? 'DayPickerNavigation_leftButton__horizontalDefault' : 'DayPickerNavigation_rightButton__horizontalDefault',
										].join(' ')}
										aria-label={ariaLabel}
										aria-disabled={disabled ? true : undefined}
										onClick={disabled ? undefined : onClick}
										onKeyUp={disabled ? undefined : onKeyUp}
										onMouseUp={disabled ? undefined : onMouseUp}
										data-testid="go-next-month"
									>
										<svg
											className="DayPickerNavigation_svg__horizontal"
											focusable="false"
											viewBox="0 0 1000 1000"
										>
											{isRTL ? (
												<path d="M336 275L126 485h806c13 0 23 10 23 23s-10 23-23 23H126l210 210c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7L55 524c-11-11-11-21 0-32l249-249c21-22 53 10 32 32z" />
											) : (
												<path d="M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z" />
											)}
										</svg>
									</div>
								) : undefined}
								isOutsideRange={(date) => {
									const isBeforeYesterday = date.isBefore(yesterday, 'day');
									const isAfterMaxDate = date.isAfter(maxDate, 'day');
									const result = isBeforeYesterday || isAfterMaxDate;

									return result;
								}}
								isRTL={isRTL}
								anchorDirection={isRTL ? 'right' : 'left'}
								orientation={isRTL ? 'horizontal' : 'horizontal'}
								monthFormat="MMMM YYYY"
								phrases={{
									closeDatePicker: t('Search.CloseDatePicker'),
									clearDates: t('Search.ClearDates'),
								}}
							/>
						</div>
						<button
							ref={this.searchDataButtonRef}
							aria-label="Select Guests"
							aria-describedby="adults rooms children"
							onClick={this.openDataWindow}
							id={SEARCH_CONSTANTS.SHARED_ATTRIBUTES_NAMES.SEARCH_DATA}
							className={classNames('data', focusedGuestsInput && 'focused')}
							data-testid="select-guests"
						>
							<UserIcon className="search-icon" aria-hidden="true" />
							<SearchData
								ref={this.searchDataRef}
								adults={guests}
								childrenAges={children_ages}
								rooms={rooms}
								onGuestsChange={this.onGuestsChange}
								onRoomsChange={this.onRoomsChange}
								onChildrenChange={this.onChildrenChange}
								onDataWindowToggle={this.handleDataWindowToggle}
								showChildrenAgesError={this.state.showChildrenAgesError}
								isAgent={profile.agent}
							/>
						</button>
					</div>
					{this.getSearchButton()}
				</div>
				{variant !== VARIANT.SMALL && <SearchMessage nights={this.getNumberOfNights()} />}
			</div>
		);
	}

	_onChange() {
		this.setState({ ...getState() });
	}

	componentDidMount() {
		SearchStore.addChangeListener(this._onChange);
		if (
			!getState().store_search_terms?.destination?.address &&
			SearchStore.isPrivateTravel() &&
			this.state.guests === 1
		) {
			SearchActions.updateGuests(2);
		}
	}

	componentWillUnmount() {
		SearchStore.removeChangeListener(this._onChange);
	}
}

SearchFull.propTypes = {
	variant: PropTypes.oneOf([VARIANT.DEFAULT, VARIANT.SMALL]),
};

export default withStyles(globalStyles)(withTranslation()(withRouter(SearchFull)));
